import { tss } from 'tss-react';
import React from 'react';
import styles from "./styles";
import Link from "@mui/material/Link";

import RailsRoutes from "../Shared/RailsRoutes";
import WebsaUITheme from "../Shared/WebsaUITheme";
import ThemeProvider from '../Shared/ThemeProvider';
import Copyright from "../Shared/Copyright/Copyright";
import LogoHeader from "../Shared/LogoHeader/LogoHeader";
import Slider from "../Shared/Slider/Slider";

export default function Error(props) {
  const theme = ThemeProvider(props.theme);
  const { classes } = tss.create(styles(theme))();

  return (
    <WebsaUITheme theme={props.theme}>
      <div className={classes.root}>
        <LogoHeader/>
        <div className={classes.slider}>
          <Slider/>
        </div>
        <div className={classes.form}>
          <div className={classes.head}>
            <p>
              Return to <Link rel="stylesheet" href={RailsRoutes.new_user_session_path()}>Sign in</Link>
            </p>
          </div>
          <div className={classes.flexColumn}>
            <span className="ico-warning_info"/>
            <span className={classes.infoBlockTitle}>
              {props.flash.alert}
            </span>
            <span className={classes.infoBlockDescription}>
              {props.flash.alert2}
            </span>
          </div>
          <Copyright/>
        </div>
      </div>
    </WebsaUITheme>
  );
}
